import { bold } from './primitives';
import type { SummarySlice } from './types';

export const commentSummaries = {
  'comment.added': ({ ctx }) => <div>Comment added to {bold(ctx.targetName)}</div>,
  'comment.replied': ({ ctx }) => <div>Reply added to a comment on {bold(ctx.targetName)}</div>,
  'comment.thread_resolved': ({ ctx }) => <div>Conversation on {bold(ctx.targetName)} resolved</div>,
  'comment.thread_reopened': ({ ctx }) => <div>Conversation on {bold(ctx.targetName)} reopened</div>,
} satisfies SummarySlice;
